import {
  AmbassadorForYouOrganism,
  AmbassadorDoctorSliderOrganism,
  AmbassadorHeroOrganism,
  AmbassadorPositiveVisionOrganism,
  AmbassadorLookingInfluenceOrganism,
  PartnerFormOrganism,
} from '../../organisms/';
import { FooterMobileTemplate } from '../footer-mobile';
import React from 'react';

export const AmbassadorMobileTemplate = () => {
  return (
    <section className="bg-waldo-dirty-white">
      <AmbassadorHeroOrganism />
      <AmbassadorPositiveVisionOrganism />
      <AmbassadorForYouOrganism />
      <AmbassadorLookingInfluenceOrganism />
      <AmbassadorDoctorSliderOrganism
        image1="nurse_1.png"
        image2="doctor_2.png"
        mainImage="doctor_3.png"
        image3="opthal_4.png"
        image4="nurse_5.png"
      />
      <PartnerFormOrganism title="Contact" buttonLabel="BECOME AN AMBASSADOR" />
      <FooterMobileTemplate />
    </section>
  );
};
